import React from 'react'
import styled from 'styled-components'
import { Route, Switch } from 'react-router-dom'

// Protected Routes
import {
  PharmacyOrderListPage, CreateNewBranchPage, Pharmacies,
  GeozoneDetailsPage, Geozones, CreateGeozonePage, SearchBar,
  PharmacyDetailsPage, BranchDetailsPage, CreateOrganisationPage,
  CreateBranchPage, BillingDetailsPage, Surgeries, SurgeryDetailsPage,
  WhiteLabels, WhiteLabelDetail, AuditLogsPage, ECommerceBanners, ECommerceCategories,
  ProblematicPharmaciesListPage, OrderDetailsPage, ECommerceGeofenceMapPage,
  DeliveryGeofenceMapPage, ServiceDetailsPage,
  ServiceConditionsPage, ServiceConditionDetailsPage, AnnouncementsListPage,
  AnnouncementCreatePage, PushNotificationsListPage,
  PushNotificationDetailsPage, CreatePushNotificationPage, ServiceConsultationsPage,
  QuestionnairesListPage,
  QuestionnairePage,
  ClinicsPage,
  CreateClinicPage,
  ModifyClinicPage,
  MasterMedicinesPage,
  MasterMedicinePage,
  /* plop:append-imports */
  ClinicMasterProductsPage,
  VirtualMedicinePage,
  ModifyClinicMasterProductPage,
  CreateClinicMasterProductPage,
} from './Views'
import AppBar from '../AppBar/AppBar'
import { FullWidthBar } from '../../healtheraComponents'
import { Redirect } from 'react-router'
import { ROUTES } from './constants'
import DashboardPage from '../DashboardPage/DashboardPage'

// These Routes are nested in App.js. The header stays static and we only change the content below it
export const ProtectedRoutes = () => {
  return (
    <Switch>
      <Route path='/' component={Layout} />
    </Switch>
  )
}

const Layout = () => (
  <div>
    <FullWidthBar>
      <AppBar />
      <Container><SearchBar /></Container>
    </FullWidthBar>
    <Container>
      <Switch>
        <Route exact path='/' render={() => <Redirect to='organisations' />} />
        <Route exact path={ROUTES.ORGANISATIONS} component={Pharmacies} />
        <Route exact path={[ROUTES.ORGANISATIONS, 'create'].join('/')} component={CreateOrganisationPage} />
        <Route exact path={[ROUTES.ORGANISATIONS, ':organisationID'].join('/')} component={PharmacyDetailsPage} />
        <Route exact path={ROUTES.PROBLEMATIC_PHARMACIES} component={ProblematicPharmaciesListPage} />
        <Route exact path='/problematic-pharmacies/:pharmacyId' component={PharmacyOrderListPage} />
        <Route exact path='/problematic-pharmacies/:pharmacyId/:orderId' component={OrderDetailsPage} />
        <Route exact path={ROUTES.REGIONS} component={Geozones} />
        <Route exact path={[ROUTES.REGIONS, 'create'].join('/')} component={CreateGeozonePage} />
        <Route exact path={[ROUTES.REGIONS, ':regionID'].join('/')} component={GeozoneDetailsPage} />
        <Route exact path={'/commission-delivery-partner'} component={DeliveryGeofenceMapPage} />
        <Route exact path='/e-commerce-activated-pharmacies' component={ECommerceGeofenceMapPage} />
        <Route exact path={ROUTES.WHITELABELS} component={WhiteLabels} />
        <Route exact path={[ROUTES.WHITELABELS, ':appId'].join('/')} component={WhiteLabelDetail} />
        <Route exact path={`${ROUTES.ECOMMERCE}/banners`} component={ECommerceBanners} />
        <Route exact path={`${ROUTES.ECOMMERCE}/categories`} component={ECommerceCategories} />
        <Route exact path={ROUTES.SURGERIES} component={Surgeries} />
        <Route exact path={[ROUTES.SURGERIES, ':surgeryID'].join('/')} component={SurgeryDetailsPage} />
        <Route exact path={[ROUTES.BRANCHES, ':branchID'].join('/')} component={BranchDetailsPage} />
        <Route exact path={[ROUTES.BRANCHES, 'create'].join('/')} component={CreateBranchPage} />
        <Route exact path='/create-new-branch/:orgID' component={CreateNewBranchPage} />
        <Route exact path='/organisation/:ID/commission/:date' component={BillingDetailsPage} />
        <Route exact path='/activity-history' component={AuditLogsPage} />
        <Route exact path={[ROUTES.SERVICES, 'conditions'].join('/')} component={ServiceConditionsPage} />
        <Route exact path={[ROUTES.SERVICES, 'conditions', ':conditionId'].join('/')} component={ServiceConditionDetailsPage} />
        <Route exact path={[ROUTES.SERVICES, 'consultations'].join('/')} component={ServiceConsultationsPage} />
        <Route exact path={[ROUTES.SERVICES, 'consultations', ':serviceId'].join('/')} component={ServiceDetailsPage} />
        <Route exact path={ROUTES.DASHBOARD} component={DashboardPage} />
        <Route exact path={ROUTES.ANNOUNCEMENTS} component={AnnouncementsListPage} />
        <Route exact path={`${ROUTES.ANNOUNCEMENTS}/create`} component={AnnouncementCreatePage} />
        <Route exact path={ROUTES.CAMPAIGNS} component={PushNotificationsListPage} />
        <Route exact path={`${ROUTES.CAMPAIGNS}`} component={PushNotificationsListPage} />
        <Route exact path={`${ROUTES.CAMPAIGNS}/create`} component={CreatePushNotificationPage} />
        <Route exact path={[ROUTES.CAMPAIGNS, ':campaignId'].join('/')} component={PushNotificationDetailsPage} />
        <Route exact path={[ROUTES.QUESTIONNAIRES].join('/')} component={QuestionnairesListPage} />
        <Route exact path={[ROUTES.QUESTIONNAIRES, ':questionnaireId'].join('/')} component={QuestionnairePage} />
        {/* plop:append-routes */}
        <ClinicRoutes />
      </Switch>
    </Container>
  </div>
);

function ClinicRoutes() {
  return (<Switch>
    <Route exact path={ROUTES.CLINICS} component={ClinicsPage} />
    <Route exact path={ROUTES.CLINICS} component={ClinicsPage} />
    <Route exact path={[ROUTES.CLINICS, 'create'].join('/')} component={CreateClinicPage} />
    <Route exact path={[ROUTES.CLINICS, 'master-medicines'].join('/')} component={MasterMedicinesPage} />
    <Route exact path={[ROUTES.CLINICS, 'master-medicines', ':masterMedicineId'].join('/')} component={MasterMedicinePage} />
    <Route exact path={[ROUTES.CLINICS, 'master-medicines', ':masterMedicineId', 'virtual-medicines', ':virtualMedicineId'].join('/')} component={VirtualMedicinePage} />
    <Route exact path={[ROUTES.CLINICS, ':clinicId', 'products'].join('/')} component={ClinicMasterProductsPage} />
    <Route exact path={[ROUTES.CLINICS, ':clinicId', 'products', 'create'].join('/')} component={CreateClinicMasterProductPage} />
    <Route exact path={[ROUTES.CLINICS, ':clinicId', 'products', ':clinicMasterProductId'].join('/')} component={ModifyClinicMasterProductPage} />
    <Route exact path={[ROUTES.CLINICS, 'conditions'].join('/')} component={ServiceConditionsPage} />
    <Route exact path={[ROUTES.CLINICS, 'conditions', ':conditionId'].join('/')} component={ServiceConditionDetailsPage} />
    <Route exact path={[ROUTES.CLINICS, 'questionnaires'].join('/')} component={QuestionnairesListPage} />
    <Route exact path={[ROUTES.CLINICS, 'questionnaires', ':questionnaireId'].join('/')} component={QuestionnairesListPage} />
    <Route exact path={[ROUTES.CLINICS, ':clinicId'].join('/')} component={ModifyClinicPage} />
  </Switch>)
}

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`
